export default {
  enterNamePlaceholder: { id: 'enter_name_placeholder' },
  optional: { id: 'optional' },
  saveSuccessMessage: { id: 'save_success_message' },
  clear: { id: 'clear' },
}
